import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.856 13.144a12.6 12.6 0 0 0 3.809 2.638c.28.124.61.05.827-.166l.818-.82c.67-.67 1.62-.67 2.206-.084l1.174 1.174a2 2 0 0 1 0 2.828l-.652.652c-.741.74-1.81 1.05-2.87.85-2.613-.494-5.474-2.012-7.923-4.461-2.45-2.45-3.967-5.31-4.461-7.923-.2-1.06.109-2.13.85-2.87l.65-.651a2 2 0 0 1 2.829 0l1.173 1.173a1.5 1.5 0 0 1 0 2.12l-.904.904a.75.75 0 0 0-.166.827 12.7 12.7 0 0 0 2.64 3.809",
      stroke: "black",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }